<div class="rounded border">
    <h5 class="text-info p-1">Stock No ubicado</h5>

    <!-- ngx-datatable -->
    <ngx-datatable class='bootstrap'
                   [columnMode]="ColumnMode.flex"
                   [loadingIndicator]="loading"
                   [headerHeight]="70"
                   [footerHeight]="50"
                   [rowHeight]="50"
                   [limit]="rowsLimit"
                   [rows]='rows'
                   [messages]="messages"
                   [footerHeight]="50"
                   [summaryRow]="true"
                   [summaryHeight]="55"
                   [summaryPosition]="summaryPosition">


        <!-- id -->
        <ngx-datatable-column name="id"
                              [flexGrow]="10">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'id')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">id</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
            </ng-template>
        </ngx-datatable-column>


        <!-- id_articulo -->
        <ngx-datatable-column name="id Art."
                              prop='id_articulo'
                              [flexGrow]="10">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'id_articulo')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">id Art.</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global">
                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                </div>

            </ng-template>
        </ngx-datatable-column>




        <!-- articulo_sku -->
        <ngx-datatable-column name="sku"
                              [flexGrow]="20">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'sku')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">SKU</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global">
                    <span [ngClass]="{'defectuoso': row.swDefectuoso == Constantes.DEFECTUOSO}"
                          [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                    <span *ngIf="row.swDefectuoso == Constantes.DEFECTUOSO">
                        <i title="Defectuoso"
                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                    </span>
                </div>

            </ng-template>
        </ngx-datatable-column>




        <!-- ean -->
        <ngx-datatable-column name="ean"
                              [flexGrow]="20">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'ean')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link"><i class="fa fa-barcode text-secondary"></i> Ean</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
            </ng-template>
        </ngx-datatable-column>





        <!-- descripcion -->
        <ngx-datatable-column name="descripcion"
                              [flexGrow]="35">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'descripcion')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer  link">Descripción</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
            </ng-template>
        </ngx-datatable-column>




        <!-- lote -->
        <ngx-datatable-column name="lote"
                              [flexGrow]="10">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'lote')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer  link">Lote</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Fecha caducidad: {{row.fecha_caducidad}}">
                    <span [ngClass]="{'defectuoso': row.swCaducado == '1'}"
                          [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                    <span *ngIf="row.swCaducado == '1'">
                        <i title="Caducado"
                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                    </span>
                </div>
            </ng-template>
        </ngx-datatable-column>






        <!-- ubiPlaya -->
        <ngx-datatable-column name="ubiPlaya"
                              pre="ubiPlaya"
                              [flexGrow]="18">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'ubiPlaya')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">Playa</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>

                <div *ngIf="row.swValidado == Constantes.ENTRADA_VALIDADA"
                     (dblclick)="dblclickCampo(value)"
                     title={{funcLib.CodUbiDecript(value)}}
                     class="monospace"
                     [innerHTML]="funcLib.resaltarTexto(value | mask: '00.00.00.00.00.00', textoDestacado | mask: '00.00.00.00.00.00')">
                </div>

                <div *ngIf="row.swValidado == Constantes.ENTRADA_NO_VALIDADA">
                    <span class=" badge badge-estado-info">Pendiente de entrada</span>
                </div>

            </ng-template>
        </ngx-datatable-column>





        <!-- pale -->
        <ngx-datatable-column name="pale"
                              prop='pale'
                              [flexGrow]="10">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'pale')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">Pale</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     title="{{row.clienteNombre}}">
                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                </div>

            </ng-template>
        </ngx-datatable-column>


        <!-- cantidad -->
        <ngx-datatable-column name="cantidad"
                              prop='cantidad'
                              [flexGrow]="10"
                              [cellClass]="'text-right'"
                              [summaryFunc]="sumaCeldas">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'cantidad')"><br>
                <div class="header"
                     title="Cantidad esperando ubicación en esta playa"
                     (click)="sort()">
                    <h6 class="pointer link">Cantidad</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <div>
                    {{value | number: '1.0-0':'es'}}
                    <small *ngIf="value && row.unidadesCaja > 0"
                           title="{{row.unidadesCaja | number: '1.0-0':'es'}} Unidades por Caja"
                           class="text-muted d-block"
                           style="margin-top: -5px;">({{value / row.unidadesCaja | number: '1.0-0':'es'}} Cajas)</small>
                </div>

            </ng-template>
        </ngx-datatable-column>




        <!-- created_at -->
        <ngx-datatable-column name="created_at"
                              prop='created_at'
                              [flexGrow]="20">
            <ng-template ngx-datatable-header-template
                         let-sort="sortFn"
                         let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'created_at')"><br>
                <div class="header"
                     (click)="sort()">
                    <h6 class="pointer link">Entrada</h6>
                </div>
            </ng-template>
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     style="font-family: 'Verdana', monospace; letter-spacing: 0.2px;"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
            </ng-template>
        </ngx-datatable-column>





    </ngx-datatable>

</div>